import React from 'react';
import { ModalBody, ModalBodyProps } from '../Modal/ModalBody';

export type SidebarBodyProps = ModalBodyProps;

export const SidebarBody = ModalBody;
